import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { translate, utils } from 'parking-react-common'

import { routing, users } from '../redux'

import SidebarMenu from '../components/SidebarMenu'
import SidebarMenuItem from '../components/SidebarMenuItem'

const MainMenu = ({ t, currentUser }) => (
    <SidebarMenu title={ t('Menu') }>
        <SidebarMenuItem
            label={ t('Dashboard') }
            link={ routing.routeFor('dashboard') }
            icon="md/home"
        />
        <SidebarMenuItem
            label={ t('Parking Lots') }
            icon="md/local-parking"
            link={ routing.routeFor('parkingLots') }
        />
        <SidebarMenuItem
            label={ t('Billing') }
            icon="fa/money"
        >
            { currentUser.is_staff && utils.featureFlag('enableTopUp') && (
                <SidebarMenuItem
                    label={ t('Top Ups') }
                    link={ routing.routeFor('topUps') }
                    icon="md/credit-card"
                />
            ) }
            <SidebarMenuItem
                label={ t('Payments') }
                link={ routing.routeFor('payments') }
                icon="md/compare-arrows"
            />
            { currentUser.is_staff && (
                <SidebarMenuItem
                    label={ t('Invoices') }
                    link={ routing.routeFor('invoices') }
                    icon="md/receipt"
                />
            ) }
            { utils.featureFlag('SHOW_REPORTS') && currentUser.is_staff && (
                <SidebarMenuItem
                    label={ t('Charts') }
                    link={ routing.routeFor('charts') }
                    icon="md/timeline"
                />
            ) }
        </SidebarMenuItem>
        <SidebarMenuItem
            label={ t('Sessions') }
            link={ routing.routeFor('sessions') }
            icon="md/history"
        />
        <SidebarMenuItem
            label={ t('External Sessions') }
            link={ routing.routeFor('externalSessions') }
            icon="md/history"
        />
        <SidebarMenuItem
            label={ t('Users') }
            icon="fa/user"
        >
            { currentUser.is_staff && (
                <SidebarMenuItem
                    label={ t('Accounts') }
                    link={ routing.routeFor('users') }
                    icon="fa/user"
                />
            ) }
            <SidebarMenuItem
                label={ t('Invitations') }
                link={ routing.routeFor('invitations') }
                icon="fa/user-plus"
            />
        </SidebarMenuItem>
        { currentUser.is_staff && (
            <SidebarMenuItem
                label={ t('Interrogations') }
                link={ routing.routeFor('interrogations') }
                icon="fa/check-circle"
            />
        ) }
    </SidebarMenu>
)

MainMenu.propTypes = {
    currentUser: PropTypes.object.isRequired
}

function mapStateToProps(state) {
    return {
        currentUser: users.getCurrent(state)
    }
}

export default connect(mapStateToProps)(translate()(MainMenu))
